<template>
    <section id="detail" class="venue-detail venue-detail-pane-width">
      <a class="panel-toggle secondary" v-on:click="toggleMainPanel()">
        <ChevronIcon/><span class="fa fa-sort-up"></span><span>Back to Venues</span>
      </a>

      <template v-if="venue.content">

        <div class="venue-detail__header">
          <div class="title-header">
            <h1 v-html="venue.title.rendered"></h1>
          </div>
        </div>

        <div class="venue-detail__content">

          <div class="venue-detail__metadata">
            <dl class="description-list">
              <div class="description-list__row">
                <dt>Capacity</dt>
                <dd>{{ venue.acf.capacity }}</dd>
              </div>
              <div class="description-list__row">
                <dt>Square Feet</dt>
                <dd>{{ formatNumber(venue.acf.square_feet) }}</dd>
              </div>
              <div class="description-list__row">
                <dt>Rate</dt>
                <dd>{{ venue.acf.rate }}</dd>
              </div>
            </dl>
          </div>

          <div class="venue-detail__details">
            <div class="venue-detail__details-header">Details</div>

            <div class="venue-detail__details-text" v-html="venue.content.rendered"></div>

            <div class="venue-detail__details-links">
              <div class="venue-detail__details-link location">
                <p>
                  <a target="_blank"
                     :href="venue.acf.location">
                    <PdfIcon/>
                    <span>Location</span></a>
                </p>
              </div>
              <div class="venue-detail__details-link schematic">
                <p>
                  <a target="_blank"
                     :href="venue.acf.schematic">
                    <PdfIcon/><span>Schematic</span></a>
                </p>
              </div>
              <div class="venue-detail__details-link pdf-picture-sheet">
                <p><a target="_blank"
                      :href="venue.acf.pdf">
                  <PdfIcon/><span>Photos</span></a></p>
              </div>
            </div>

          </div>
        </div>
        <!--<ul v-for="(image, key) of venueImages">
          <li>
            <img :src="image.image.url" image alt="">
          </li>
        </ul>-->
      </template>
    </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import PdfIcon from '@/components/PdfIcon.vue';
import ChevronIcon from '@/components/image-slider/ChevronIcon.vue';

export default {
    name    : "venue",
  components: { ChevronIcon, PdfIcon },
    props   : [
      'venueImages'
    ],
    data () {
      return {}
    },
    computed: {
      ...mapState([
        'venue',
        'venues',
      ]),
      isOpen () {
        return this.$store.state.isDetailPanelOpen;
      },
    },
    mounted () {
      // this.toggleDetailPanel(true);

      // eventHub.$on('open-panels', () => {
      //   this.isClosed = false;
      // });
    },
    methods : {
      ...mapMutations([
        'toggleDetailPanel',
        'toggleMainPanel',
      ]),
      isNumeric(str) {
        if (typeof str != "string") return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
      },
      formatNumber(num) {
        return this.isNumeric(num) ? Number(num).toLocaleString('en-US') : num
      }
    }
  }
</script>

<style scoped>
    .panel {
        top: 0;
    }

    a {
        cursor: pointer;
    }

    .panel:before {
        left: 0;
    }
</style>
